var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"thumb",attrs:{"to":_vm.$relativeUrl(_vm.data.link)}},[(_vm.data.gds_featured_image)?_c('Figure',{attrs:{"data":{
      value: {
        image: _vm.data.gds_featured_image,
      },
      settings: {}
    }}}):_vm._e(),_c('Title',{attrs:{"value":_vm.data.title.rendered}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }